export const GTM_CONTAINER = 'GTM-WVFDRQT';

export const API_URL = process.env.API_URL;